<template>
    <span v-if="speed == null || speed == 'undefined'">
        _
    </span>
    <span v-else-if="!Number.isInteger(speed)">
        {{ speed }}
    </span>
    <span v-else-if="speed >= 130" class="ui-badge status-badge--low">
        <font-awesome-icon :icon="['fas', 'car-side']" class="me-1"/> {{ speed }} km/h</span>
    <span v-else-if="speed >= 90" class="ui-badge status-badge--medium">
        <font-awesome-icon :icon="['fas', 'car-side']" class="me-1"/> {{ speed }} km/h</span>
    <span v-else-if="speed > 0" class="ui-badge status-badge--ok">
        <font-awesome-icon :icon="['fas', 'car-side']" class="me-1"/> {{ speed }} km/h</span>
    <span v-else class="ui-badge alert-badge--neutral">
        <font-awesome-icon :icon="['fas', 'car-side']" class="me-1"/> {{ speed }} km/h</span>
</template>

<script>
export default {
    props: ['speed']
}
</script>